import PaymentLogos from './payment-logo-view'

export default PaymentLogos
